import * as types from "./types";

const mutations = {
  [types.LOADING_ELEARN](state, value) {
    state.loading = value;
  },
  [types.POST_ADMIN](state, elearn) {
    state.elearn = elearn;
  },
  [types.GET_USER](state, elearn) {
    state.elearn = elearn;
  },
};

export default mutations;
